import { useState } from "react";
import { ALL, NONE } from "@miplatform/constants";
import { buildSearchQuery } from "@miplatform/utils";
import {
  OrderSearchFilters,
  OrdersSearchApiRequest,
  OrdersSearchFilterObject,
} from "../OrderSearch.types";
import { ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS } from "../OrdersSearch.constants";

const initialOrdersFiltersSearch: OrderSearchFilters = {
  groupBy: NONE,
  sortBy: NONE,
  orderTemplateId: ALL,
  orderStatus: ALL,
  builderId: ALL,
  communityId: ALL,
};

export const useOrdersSearch = ({ search }: UseOrdersSearchProps) => {
  const [filters, setFilters] = useState<OrderSearchFilters>(
    initialOrdersFiltersSearch
  );

  const getOrdersSearchFilterQuery = (params: OrdersSearchApiRequest) => {
    const searchQuery = buildSearchQuery(search, ["home/address/addressLine1"]);
    const filterObj: OrdersSearchFilterObject = { ...searchQuery };

    let sortBy = "home/address/addressLine1 asc";

    if (filters) {
      if (filters.builderId && filters.builderId !== ALL) {
        filterObj["home/builderId"] = {
          type: "guid",
          value: filters.builderId,
        };
      }
      if (filters.communityId && filters.communityId !== ALL) {
        filterObj["home/communityId"] = {
          type: "guid",
          value: filters.communityId,
        };
      }

      if (filters.orderTemplateId && filters.orderTemplateId !== ALL) {
        filterObj.orderTemplateId = {
          type: "guid",
          value: filters.orderTemplateId,
        };
      }

      if (filters.orderStatus && filters.orderStatus !== ALL) {
        filterObj.orderStatus = {
          eq: filters.orderStatus,
        };
      }

      if (filters.sortBy && filters.sortBy !== NONE) {
        switch (filters.sortBy) {
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.RECEIVED_DATE:
            sortBy = "receivedDate desc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.CONFIRMED_SCHEDULE_DATE:
            sortBy = "confirmedScheduleDate asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.APPROVED_DATE:
            sortBy = "approvedStartDate asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.ORDER_TYPE:
            sortBy = "orderTemplateName asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.BUILDER:
            sortBy = "home/builderName asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.COMMUNITY:
            sortBy = "home/communityName asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.ORDER_STATUS:
            sortBy = "orderStatus asc";
            break;
          case ORDERS_SEARCH_GROUP_AND_SORT_BY_KEYS.REQUESTER:
            sortBy = "requester/firstName asc";
            break;
          default:
            sortBy = "home/address/addressLine1 asc";
        }
      }
    }

    return {
      ...params,
      filters: filterObj,
      sort: sortBy,
      groupBy: "home/phase",
    };
  };

  const resetFilters = () => {
    setFilters(initialOrdersFiltersSearch);
  };

  return {
    filters,
    setFilters,
    initialFilters: initialOrdersFiltersSearch,
    getOrdersSearchFilterQuery,
    resetFilters,
  };
};

interface UseOrdersSearchProps {
  search: string;
}
